import { render } from "./ThemesSelector.vue?vue&type=template&id=726a81da"
import script from "./ThemesSelector.vue?vue&type=script&lang=js"
export * from "./ThemesSelector.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__